import e from "styled-components";
import i from "../../utils/colors.js";
import { device as t } from "../../utils/device.js";
const l = e.div`
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;

  @media ${t.isDesktop} {
    flex-direction: row;
  }
`, a = e.div`
  border-bottom: 1px solid ${i.darkGrey10};
  width: 100%;
  height: 0;
  padding: 0;
  margin: 0;

  @media ${t.isDesktop} {
    border-bottom: none;
    height: 70px;
    width: 0px;
    border-right: 1px solid ${i.darkGrey10};
    margin: 0px 64px;
  }
`, d = e.div`
  flex: 1;
  @media ${t.isTablet} {
    padding: 34px;
  }
  @media ${t.isMobile} {
    padding: 38px;
  }
`, s = e.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media ${t.isMobile}, ${t.isTablet} {
    padding: 21px;
  }
`, p = e.div`
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  color: ${i.blueGrey};
`, x = e.div`
  display: flex;
  flex-direction: column;
`, m = e.div`
  margin-right: 32px;

  svg {
    width: 54px;
    height: 54px;
  }
`, c = e.div`
  font-family: VIC;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.16px;
  line-height: 1.88;
  color: ${i.blueGrey};
`, f = e.div`
  font-family: VIC;
  font-size: 34px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.34px;
  line-height: 0.88;
  color: ${i.blueGrey};
`;
export {
  m as ClockWrapper,
  a as Divider,
  p as Tagline,
  d as TaglineContainer,
  f as TextBottom,
  x as TextContainer,
  c as TextTop,
  s as TimeContainer,
  l as Wrapper
};
